import React, { useState, useEffect, useMemo } from 'react';
import { Fab, Dialog, Box, Typography, Grid } from '@mui/material';
import '../../../App.css';
import {
  RESET_DATE_RANGE,
  SET_DATE_RANGE,
  SHOW_NOTIFICATION,
  WFHAttribute,
  LeavesLoaderAttribute,
} from '../../../constants';
import LeaveStatusCardComponent from '../../../components/LeaveStatusCard/LeaveStatusCardComponent';
import PaginationComponent from '../../../components/Pagination/Pagination';
import AddIcon from '@mui/icons-material/Add';
import LeaveCardComponent from '../LeavesStatus/LeaveCountCard/LeaveCountCardComponent';

import LeaveApplicationComponent from './LeaveApplicationComponent';
// import PieChartComponent from '../../../components/PieChart/PieChartComponent';
import { getUserLeavesSummary } from '../../../services/UserService';
import {
  getUserData,
  getUserLeaves,
  getUserManagers,
} from '../../../services/UserService';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../../services/KeycloakService';
import GenericLoader from '../../../components/Loader/GenericLoader';
import { NO_LEAVES, NO_LEAVE_SUMMARY } from '../LeavesConstants';
import { getHolidays } from '../../../admin/Services/MasterdataService';
import moment from 'moment';
import GenericFilterDrawer from '../../../components/GenericFilter/GenericFilterDrawer';
import { isQuarterlyCasualAccounting } from '../../../utils/casualLeaveUtils';
import {
  resetFilterDataState,
  setFilterConfig,
} from '../../../modules/filter/filterAction';
import { checkFilterIconVisibility } from '../../../components/GenericFilter/FilterIconVisibilityCheck';
import { useLocation } from 'react-router-dom';
import { cardComponentCollapse } from '../../../modules/cardState/cardAction';
import { getLeaveTypeList } from '../../../services/LeaveService';
import { getCasualLeaveAccounting } from '../../../services/CasualLeaveAccountingService';
import HttpService from '../../../services/HttpService';
import { ADMIN_PATH } from '../../../url';

const LeaveListComponent = (props) => {
  const [loader, setLoader] = React.useState(true);
  const [pageNo, setPageNo] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [editableLeave, setEditableLeave] = React.useState({});
  const [editable, setEditable] = React.useState(false);
  const [recipients, setRecipients] = React.useState([]);
  const [managers, setManagers] = React.useState([]);
  const currentUserId = () => KeycloakService.getUserDetail();
  const [leaveSummary, setLeaveSummary] = React.useState([]);
  const [casualLeaveAccounting, setCasualLeaveAccounting] = React.useState(null);
  // const [leavesPieData, setLeavesPiedata] = React.useState([]);
  const dispatch = useDispatch();
  const [savedStartDate, setSavedStartDate] = React.useState(new Date());
  const [savedEndDate, setSavedEndDate] = React.useState(new Date());
  const dateRangeState = useSelector((state) => state.dateRangeState);
  const [showError, setShowError] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = React.useState();
  const [page, setPage] = React.useState(1);
  const [leaveList, setleaveList] = React.useState([]);
  const [refresh, setRefresh] = React.useState(true);
  const [officialHolidays, setOfficialHolidays] = React.useState([]);

  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);
  const tabType = new URLSearchParams(searchString).get('type');

  const [resetFilter, setResetFilter] = useState(false);

  const [options, setOptions] = useState({});

  const filterState = useSelector((state) => state.filterState);

  const _axios = HttpService.getAxiosClient();

  const getLeaveTypeData = async () => {
    const year = new Date().getFullYear();
    const newData = await getLeaveTypeList(year);
    setOptions({ ...options, leave: newData?.data });
  };

  const getLeavesSummary = async () => {
    const leaveSummary = await getUserLeavesSummary(
      currentUserId(),
      process.env.REACT_APP_TENANT_ID,
    );
    const year = new Date().getFullYear();
    const leaveList = await getLeaveTypeList(year);
    const accountingResponse = await getCasualLeaveAccounting(
      currentUserId(),
      year,
    );
    if (leaveSummary.status !== 200) {
      dipatchNotification(leaveSummary.type, leaveSummary.message);
    }
    if (leaveSummary.isError === false) {
      setLeaveSummary(leaveSummary.data.data.leavesRecordDTOList);
      setCasualLeaveAccounting(
        accountingResponse.isError === false ? accountingResponse.data.data : null,
      );
      let total = 0;
      let used = 0;
      const leaveTypeCounts = {};
      leaveSummary.data.data.leavesRecordDTOList.forEach((leave) => {
        const leaveTypeName = leaveList?.data?.find(
          (item) => item.id === leave.leaveId,
        )?.leaveName;
        const isQuarterlyCasual = isQuarterlyCasualAccounting(leave);
        if (!isQuarterlyCasual) {
          total += leave.totalAllowedLeaves || 0;
          used += leave.usedLeaves || 0;
        }
        // const leaveTypeName = leave.leaveType;
        if (leaveTypeName && !isQuarterlyCasual) {
          if (!leaveTypeCounts[leaveTypeName]) {
            leaveTypeCounts[leaveTypeName] = 0;
          }
          leaveTypeCounts[leaveTypeName] += leave.usedLeaves;
        }
      });

      // const templatePieData = Object.entries(leaveTypeCounts).map(
      //   ([type, value]) => ({
      //     id: `${type} Used`,
      //     label: `${type} Used`,
      //     value: `${value}`,
      //   }),
      // );

      // templatePieData.push({
      //   id: 'Overall Available',
      //   label: 'Leaves Available',
      //   value: total - used,
      // });
      // setLeavesPiedata(JSON.parse(JSON.stringify(templatePieData)));
    }
  };

  useEffect(() => {
    getLeavesSummary();
  }, []);

  const filterConfiguration = {
    inputField: [
      [
        ['status', 'Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['CANCELLED', 'Cancelled'],
        ],
      ],
    ],
    checkField: [['isUpdatedByAdmin', 'Updated by HR']],
    dropdownField: [['Leave', 'leave', 'leaveName', 'id']],
  };

  const emptyFilterData = {
    leaveName: '',
    leaveId: '',
    status: '',
    isUpdatedByAdmin: false,
    startDate: '',
    endDate: '',
  };

  const getHoliday = async () => {
    const user = await getUserData(currentUserId());
    if (user?.data?.locationId) {
      const holidayList = await getHolidays(user.data.locationId);
      const arr = [];
      if (holidayList.isError === false) {
        holidayList.data.map((obj) =>
          arr.push(moment(obj.date).format('DD MM YYYY')),
        );
      }
      setOfficialHolidays(arr);
    }
  };

  const getLeaveName = async (request) => {
    const year = new Date().getFullYear();
    const leaveList = await getLeaveTypeList(year);
    const leaveTypeName = leaveList?.data?.find(
      (item) => item.id === request.leaveId,
    );
    request.leaveType = leaveTypeName?.leaveName;
  };

  const getLeaveList = async () => {
    const userLeaves = await getUserLeaves(
      currentUserId(),
      filterState,
      filterState.isUpdatedByAdmin,
      pageSize,
      pageNo,
    );
    if (userLeaves.status !== 200) {
      dipatchNotification(userLeaves.type, userLeaves.message);
    }
    if (userLeaves.isError === false) {
      setTotalPage(userLeaves.data.data.totalPages);
      await Promise.all(
        userLeaves?.data.data.content.map(async (request) => {
          await getLeaveName(request);
        }),
      );
      setleaveList(userLeaves.data.data.content);

      setLoader(false);
      const reportingManagers = await getUserManagers(currentUserId());
      const user = await getUserData(currentUserId());
      if (reportingManagers.status !== 200) {
        dipatchNotification(reportingManagers.type, reportingManagers.message);
      }
      if (reportingManagers.isError === false) {
        if (
          user.data.employeePrivileges &&
          user.data.employeePrivileges.SELF_APPROVE_LEAVE_WFH === 'YES'
        ) {
          user.data['firstName'] = 'You: ' + user.data['firstName'];
          setManagers([...reportingManagers.data, user.data]);
        } else {
          setManagers(() => reportingManagers.data);
        }
      }
    }
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefresh(!refresh);
  };
  const resetThings = () => {
    for (let arrayOfArrays of filterConfiguration.dropdownField) {
      setOptions({ ...options, [arrayOfArrays[1]]: [] });
    }
    dispatch(setFilterConfig(filterConfiguration));
    if (tabType !== 'LEAVE') {
      dispatch(resetFilterDataState());
      dispatch({
        type: RESET_DATE_RANGE,
      });
      dispatch(cardComponentCollapse());
    }
  };

  useEffect(() => {
    resetThings();
    getLeaveTypeData();
    setResetFilter(true);
  }, [location]);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) {
      getLeaveList();
      getHoliday();
    }
  }, [refresh, resetFilter]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefresh(!refresh);
  };

  const toggleOpen = () => {
    setTimeout(() => {
      setSavedStartDate(dateRangeState.startDate);
      setSavedEndDate(dateRangeState.endDate);
    }, 200);
    dispatch({
      type: RESET_DATE_RANGE,
    });
    setOpen(!open);
    setEditableLeave({});
    setRecipients(() => []);
    setEditable(false);
  };

  const toggleClose = () => {
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        ...dateRangeState,
        startDate: savedStartDate,
        endDate: savedEndDate,
      },
    });
    setOpen(false);
    setEditableLeave({});
    setRecipients(() => []);
    setEditable(false);
  };

  const toggleEditOpen = async (leave) => {
    setEditableLeave(leave);
    setTimeout(() => {
      setSavedStartDate(dateRangeState.startDate);
      setSavedEndDate(dateRangeState.endDate);
    }, 200);
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        ...dateRangeState,
        startDate: leave.startDate,
        endDate: leave.endDate,
      },
    });
    const arr = leave.applicationStatusDTOS.map((subject) =>
      getUserData(subject.approverId),
    );
    const list = await Promise.all(arr);
    setRecipients(() => list.map((rec) => rec.data));

    setEditable(true);
    setOpen(!open);
  };

  return (
    <>
      {loader ? (
        <div>
          <GenericLoader
            rectAttributes={LeavesLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box className="main-content-overlay" style={{ marginTop: '20px' }}>
          <div>
            {leaveSummary.length == 0 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                }}
              >
                <div>
                  <Typography>{NO_LEAVE_SUMMARY}</Typography>
                </div>
              </div>
            ) : (
              <>
                {leaveSummary
                  .filter(
                    (leave) =>
                      leave.totalAllowedLeaves > 0 ||
                      leave.casualLeaveAccountingEnabled === true,
                  )
                  .map((leave) => (
                    <LeaveCardComponent
                      key={leave.leaveId}
                      leave={leave}
                      accountingSnapshot={casualLeaveAccounting}
                    />
                  ))}
              </>
            )}
          </div>
          {/* <div>
            <div className="leave-pie-container">
              <PieChartComponent data={leavesPieData} />
            </div>
          </div> */}
        </Box>
      )}
      {loader ? (
        <div style={{ height: '70vh', overflow: 'hidden' }}>
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <>
          <Fab
            color="primary"
            style={{
              right: 25,
              bottom: 80,
              position: 'fixed',
              zIndex: 1051,
              // the zIndex of edit and delete buttons is 1050
            }}
            onClick={() => {
              toggleOpen();
            }}
          >
            <AddIcon />
          </Fab>
          {checkFilterIconVisibility(
            filterState,
            emptyFilterData,
            leaveList,
          ) && <GenericFilterDrawer options={options} />}
          <Box
            sx={{
              overflow: 'hidden',
            }}
          >
            {leaveList.length != 0 ? (
              leaveList.map((leave, index) => {
                return (
                  <LeaveStatusCardComponent
                    getLeaveList={getLeaveList}
                    key={leave.id}
                    leave={leave}
                    leaveStatus={leave.status}
                    toggleEditOpen={toggleEditOpen}
                    setPage={setPage}
                    setPageNo={setPageNo}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                );
              })
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                }}
              >
                <div>
                  <Typography>{NO_LEAVES}</Typography>
                </div>
              </div>
            )}
          </Box>
          {leaveList.length ? (
            <Box className="page-holder" sx={{ padding: '8px' }}>
              <PaginationComponent
                count={totalPage}
                page={page}
                pageChange={pageChange}
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
              />
            </Box>
          ) : (
            <></>
          )}
          <Dialog
            open={open}
            onClose={() => toggleClose()}
            fullWidth
            maxWidth="md"
          >
            <LeaveApplicationComponent
              closeFunction={toggleClose}
              getLeaveList={getLeaveList}
              getLeavesSummary={getLeavesSummary}
              editableLeave={editableLeave}
              editable={editable}
              editRecipients={recipients}
              presetRecipients={managers}
              officialHolidays={officialHolidays}
            />
          </Dialog>
        </>
      )}
    </>
  );
};

export default LeaveListComponent;
